export default __webpack_public_path__ + "static/media/how-to-use.7fbccd00.svg";